import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { closeWebView } from 'utils'

// ------------------------------------
// Constants
// ------------------------------------
export const PAYMENT_AUTHORIZATION_PAYMENT_PRIORITY = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  SUBMIT_REQUEST: null,
  SUBMIT_SUCCESS: null,
}, 'PAYMENT_AUTHORIZATION_PAYMENT_PRIORITY')

// ------------------------------------
// Actions
// ------------------------------------
export function init(callback) {
  return (dispatch) => {
    dispatch(callAPI({
      dispatch: dispatch,
      endpoint: '/cgs/api/cashdesk/reloadDeductChannel',
      method: 'POST',
      requestAction: PAYMENT_AUTHORIZATION_PAYMENT_PRIORITY.INIT_REQUEST,
      successAction: PAYMENT_AUTHORIZATION_PAYMENT_PRIORITY.INIT_SUCCESS,
      success: function(result) {
        typeof callback === 'function' && callback(result)
      }
    }))
  }
}

export function submit(data) {
  return dispatch => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/cgs/api/personal/member/preference/save',
        method: 'POST',
        body: {
          type: 'DEFAULT_AUTO_DEBIT_PAY',
          ...data
        },
        requestAction: PAYMENT_AUTHORIZATION_PAYMENT_PRIORITY.SUBMIT_REQUEST,
        successAction: PAYMENT_AUTHORIZATION_PAYMENT_PRIORITY.SUBMIT_SUCCESS,
        success: function(result) {
          closeWebView()
        }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PAYMENT_AUTHORIZATION_PAYMENT_PRIORITY.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [PAYMENT_AUTHORIZATION_PAYMENT_PRIORITY.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [PAYMENT_AUTHORIZATION_PAYMENT_PRIORITY.INIT_REQUEST]: (state, action) => state,
  [PAYMENT_AUTHORIZATION_PAYMENT_PRIORITY.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: true
}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'paymentAuthorizationPaymentPriority',
    reducerMap: {
      paymentAuthorizationPaymentPriorityState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
